import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

const TabContainer = styled.div`
  display: flex;
  position: relative;
  background-color: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 4px;
  width: fit-content;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const Tab = styled.button`
  padding: 10px 20px;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 700;
  border-radius: 999px;
  cursor: pointer;
  z-index: 1;
  color: ${({ active }) => (active ? "var(--elementAlt)" : "var(--element)")};
  transition: color 0.2s ease;

  @media (max-width: 900px) {
    font-size: 11px;
    font-weight: 700;
    padding: 15px 14px;
    flex: 1;
  }
`;

const Pill = styled.div`
  position: absolute;
  top: 4px;
  left: ${({ left }) => `${left}px`};
  width: ${({ width }) => `${width}px`};
  height: calc(100% - 8px);
  background-color: var(--accent);
  border-radius: 999px;
  transition: all 0.3s ease;
  z-index: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const AnimatedPillTabs = ({
  tabs = [],

  activeIndex,
  setActiveIndex,
}) => {
  const [pillStyle, setPillStyle] = useState({ left: 0, width: 0 });
  const tabRefs = useRef([]);

  useEffect(() => {
    const currentTab = tabRefs.current[activeIndex];
    if (currentTab) {
      setPillStyle({
        left: currentTab.offsetLeft,
        width: currentTab.offsetWidth,
      });
    }
  }, [activeIndex, tabs]);

  const handleTabClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <TabContainer>
      <Pill left={pillStyle.left} width={pillStyle.width} />
      {tabs.map((item, index) => (
        <Tab
          key={item.label}
          active={index === activeIndex}
          onClick={() => handleTabClick(index)}
          ref={(el) => (tabRefs.current[index] = el)}
        >
          {item.label}
        </Tab>
      ))}
    </TabContainer>
  );
};

export default AnimatedPillTabs;
